import { RollingDatePointDisplayType } from '../DisplayTypes';
import { RollingDatePointInputType } from '../InputTypes';
import { TODAY } from '../rollingDates/RollingDatePointOptionValues';
import { makeOperator } from './Operator';
import RollingDatePointConfig, { validateRollingDatePointConfig } from '../rollingDates/RollingDatePointConfig';
export const name = 'BeforeRollingDatePoint';
export default makeOperator({
  displayType: RollingDatePointDisplayType,
  inputType: RollingDatePointInputType,
  name,
  values: [{
    defaultValue: RollingDatePointConfig.fromRollingDatePointOptionValue(TODAY),
    isIterable: false,
    // @ts-expect-error ts-migrate(2322) FIXME: Type '(opts?: RollingDatePointConfigType | {}) => boole... Remove this comment to see the full error message
    isValid: validateRollingDatePointConfig,
    name: 'value'
  }]
});